import React, { useEffect, useState } from "react";
import {
  Plan,
  createStep,
  createPlan,
  getThreadPlans,
} from "../api/client";
import PlanBuilder from "./PlanBuilder";

type ThreadWorkspaceProps = {
  threadId: number;
  onOpenProject: (plan: Plan) => void;
  introduction?: boolean;
};

export default function ThreadWorkspace({
  threadId,
  onOpenProject,
  introduction = false,
}: ThreadWorkspaceProps) {

  const [plans, setPlans] = useState<Plan[]>([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [successMessage, setSuccessMessage] = useState<string | null>(null);
 
  useEffect(() => {
    let cancelled = false;

    async function loadPlans() {
      setLoadingPlans(true);
      setError(null);

      try {
        const data = await getThreadPlans(threadId);
        if (cancelled) return;

        setPlans(data);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Failed to load plans");
        }
      } finally {
        if (!cancelled) {
          setLoadingPlans(false);
        }
      }
    }

    loadPlans();

    return () => {
      cancelled = true;
    };
  }, [threadId]);

   useEffect(() => {
  if (!successMessage) return;

  const timer = setTimeout(() => {
    setSuccessMessage(null);
  }, 3000);

  return () => clearTimeout(timer);
}, [successMessage]);

  async function handleAIGeneratedPlan(
  aiSteps: { title: string; description: string }[],
  goal: string
) {
  try {
    setError(null);

    console.log("AI steps received:", aiSteps);

    const createdPlan = await createPlan({
      thread_id: threadId,
      title: goal,
      description: "Generated by Sanctuary from your goal.",
    });

    console.log("Created plan:", createdPlan);

    setPlans((prev) => [...prev, createdPlan]);

  await Promise.all(
  aiSteps.map((step, index) =>
    createStep(createdPlan.id, {
      title: step.title,
      description: step.description || undefined,
      position: index + 1,
    })
  )
);

onOpenProject(createdPlan);
  } catch (err) {
    console.error("Failed to create guided plan:", err);
    setError(
      err instanceof Error ? err.message : "Failed to create guided plan"
    );
  }
}

  return (
  <section className="thread-workspace">
    <div className="workspace-column">
      
      <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.75rem",
  }}
>
  <h2 style={{ margin: 0 }}>Plans</h2>
  <div style={{ display: "flex", gap: "0.5rem" }}>
  </div>
</div>

<PlanBuilder onPlanCreated={handleAIGeneratedPlan} introduction={introduction} />
     </div> 
    <div className="workspace-column">
  <h2>{introduction ? "Projects already here" : "Your projects"}</h2>

  {introduction ? (
    <p style={{ opacity: 0.78 }}>
      If you already started something, you can open it. Otherwise create your first project on the left.
    </p>
  ) : null}

  {loadingPlans ? <p>Loading projects...</p> : null}

  <div className="plan-list">
    {plans
      .filter((plan) => !plan.is_archived)
      .map((plan) => (
        <div key={plan.id} className="plan-card">
          <strong>{plan.title}</strong>
          {plan.description ? <span>{plan.description}</span> : null}

          <button type="button" onClick={() => onOpenProject(plan)}>
            Continue
          </button>
        </div>
      ))}
  </div>

  {successMessage ? <p className="workspace-success">{successMessage}</p> : null}
  {error ? <p className="workspace-error">{error}</p> : null}
</div>
  </section>
);
}
